import { $doc, $body } from "../utils/globals";
import isMobile from '../utils/isMobile';


$('.js-toggle-search').on('click', function() {
  $body.addClass('search-modal-visible')
})

$('.js-search-close').on('click', function() {
  removeClass();
})

$doc.on('click', function(e) {
  if ( !e.target.closest(".search-modal .search__content") && !e.target.closest(".js-toggle-search") ) {
    removeClass();
  }
});

function removeClass() {
  $body.removeClass('search-modal-visible');
}
